import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Stock } from "../models/Stock.model";
import { Produit } from "../models/Produit.model";
import { ProduitService } from "../_services/Produit.service";
import { StockService } from "../_services/stock.service";
import { NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: "app-tissu",
  templateUrl: "./produitStock.component.html",
  styleUrls: ["./produit.component.css"],
})
export class ProduitStockComponent implements OnInit {
  qteTotal = 0;
  items = [
    { id: 1, libelle: "Entree" },
    { id: 2, libelle: "Sortie" },
  ];
  selected = { id: 0, libelle: "" };
  items1: any;
  selected1 = { id: 0 };

  stock: Stock;

  qte = 0;
  Inventaire: any;
  tissu: Produit = new Produit();

  constructor(
    private tissuservice: ProduitService,
    private stockservice: StockService,
    private spinner: NgxSpinnerService,

    private route: ActivatedRoute
  ) {}

  getValues() {
    console.log(this.selected);
  }
  /* getValues1() {

    console.log(this.selected1);
    this.stock=this.stocks.filter((a)=>a.couleur_id==this.selected1.id)[0];
    this.qteTotal=this.qte+parseInt(this.stock.qtestock) ;

    console.log(this.stock);


  }*/
  public ngOnInit() {
    this.stock = new Stock();
    if (this.route.snapshot.paramMap.get("id")) {
      this.spinner.show();
      this.selected = { id: 0, libelle: "" };
      this.tissuservice
        .getOneData(this.route.snapshot.paramMap.get("id"))
        .subscribe((data: Produit) => {
          console.log(data);
          this.tissu = data;

          this.stockservice.getOneStock(data.id).subscribe((data: Stock) => {
            console.log(data);
            this.stock = data;
            this.spinner.hide();
          });
        });
    }

    ///////
    var pageHeader = $(".content-header").find("b");
    var adminForm = $(".admin-form");
    var buttons = adminForm.find(".button");
    var Panel = adminForm.find(".panel");
    setTimeout(function () {
      adminForm.addClass("theme-success");
      Panel.addClass("panel-success");
      pageHeader.addClass("text-success");

      buttons.removeClass().addClass("button btn-success");
    }, 800);
    //////
  }

  insertData() {
    this.spinner.show();
    if (this.selected.id == 1) {
      console.log("papa");
      console.log(this.qte);
      console.log(this.tissu.quantite);
      this.stock.qteStock =
        parseInt(this.stock.qteStock) + parseInt(this.qte.toString());
      this.tissu.quantite =
        parseInt(this.tissu.quantite) + parseInt(this.qte.toString());
      this.tissuservice.updateData(this.tissu.id, this.tissu).subscribe(() => {
        console.log("entree");
      });
    } else {
      this.stock.qteStock =
        parseInt(this.stock.qteStock) - parseInt(this.qte.toString());
      this.tissu.quantite =
        parseInt(this.tissu.quantite) - parseInt(this.qte.toString());
      this.tissuservice.updateData(this.tissu.id, this.tissu).subscribe(() => {
        console.log("SORTIE");
      });
    }

    this.stockservice.updateData(this.stock.id, this.stock).subscribe(() => {
      console.log("dane lo");
      /* let inv=new InventaireModel();
      inv.qtefinal=parseInt(this.stock.qtestock)+parseInt(this.qte.toString())   ;
        inv.qteinit=this.stock.qtestock;
          inv.qtemaj=this.qte;
          inv.type=this.selected.libelle;
          inv.stock_id=this.stock.id;
          this.inventaireservice.insertData(inv).subscribe(
            ()=>{
              console.log("data");
            }
          )*/
      this.spinner.hide();
      this.precedentPage();
    });
  }

  cool() {
    console.log("dane");

    console.log(parseInt(this.stock.qteStock));
    if (this.selected.id == 1) {
      this.qteTotal =
        parseInt(this.qte.toString()) + parseInt(this.stock.qteStock);
    } else {
      this.qteTotal =
        parseInt(this.stock.qteStock) - parseInt(this.qte.toString());
    }
  }
  precedentPage() {
    window.history.back();
  }
  setFileData($event, d) {
    this.getBase64($event, d);
  }

  getBase64(event, d) {
    let me = this;
    let file = event.target.files[0];
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      //me.modelvalue = reader.result;
      console.log(reader.result);
      d.url = reader.result;
      console.log(d);
    };
    reader.onerror = function (error) {
      console.log("Error: ", error);
    };
  }
}
